import rcbExitIntentModal from './rcbExitIntentModal';

window.addEventListener('load', () => {
  rcbExitIntentModal.initialize();
});
